import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.7406 17.6C12.3438 15.5938 16 10.7312 16 8C16 4.6875 13.3125 2 10 2C6.6875 2 4 4.6875 4 8C4 10.7312 7.65625 15.5938 9.25938 17.6C9.64375 18.0781 10.3562 18.0781 10.7406 17.6ZM10 6C10.5304 6 11.0391 6.21071 11.4142 6.58579C11.7893 6.96086 12 7.46957 12 8C12 8.53043 11.7893 9.03914 11.4142 9.41421C11.0391 9.78929 10.5304 10 10 10C9.46957 10 8.96086 9.78929 8.58579 9.41421C8.21071 9.03914 8 8.53043 8 8C8 7.46957 8.21071 6.96086 8.58579 6.58579C8.96086 6.21071 9.46957 6 10 6Z",
		fill: "#0D2976"
	})
});
export default SvgLocation;
